import { useContext } from 'react'

import { PpvTrackingContext } from '../state/PpvTrackingProvider.tsx'
import { PpvTrackingContextState } from '../types'

export const usePpvTracking = (): PpvTrackingContextState => {
  const context = useContext<PpvTrackingContextState>(PpvTrackingContext)

  if (context === undefined) {
    throw new Error('usePPVTracking must be used within PPVTrackingProvider')
  }

  return context
}
